import React, {useEffect, useState} from 'react'
import useTranslation from '../../../i18n/useTranslation'
import SocialSignin from './Social'
import EmailSignin from './Email'
import {TabContent, TabPane} from 'reactstrap'
import {useLocation} from 'react-router-dom'
import FullPassword from '../FullSignin'
import Signup from '../Signup'
import RecoveryPasswordPage from '../RecoveryPassword'

const Signin = () => {
  const {translate} = useTranslation()
  const [state, setState] = useState(1)
  useEffect(() => {
    const storage = global.localStorage.getItem('loggedUser')
    global.localStorage.removeItem('signupEmail')
    global.localStorage.removeItem('foundUser')
    if (storage) {
      setState(2)
    }
  }, [])
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const isEducator = searchParams.get('isEducator')
  const action = searchParams.get('action')
  const expired = searchParams.get('expired')
  useEffect(() => {
    if (isEducator === 'true') setState(4)
  }, [isEducator])
  useEffect(() => {
    if (action === 'recovery') setState(5)
    else if (action === 'signup') setState(3)
  }, [action])
  const [defaultEmail, setDefaultEmail] = useState(null)

  return (
    <TabContent activeTab={state}>
      <TabPane tabId={1}>
        <p className='form-domain'>admin.zinkerz.com</p>
        <h2 className='form-heading'>Staff Sign In</h2>
        <p className='form-sub'>Sign in to access the Zinkerz operations portal.</p>
        {expired === '1' ? (
          <div className='alert-box'>
            <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='#c0292f' strokeWidth='2.2' strokeLinecap='round' strokeLinejoin='round' style={{flexShrink: 0, marginTop: '1px'}}>
              <circle cx='12' cy='12' r='10' />
              <line x1='12' y1='8' x2='12' y2='12' />
              <circle cx='12' cy='16' r='0.5' fill='#c0292f' />
            </svg>
            Your session expired. Please sign in again.
          </div>
        ) : null}
        <SocialSignin googleLabel='Continue with Google' />
        <div className='divider'>
          <span className='divider-text'>or continue with email</span>
        </div>
        <EmailSignin
          emailLabel='Work Email'
          emailPlaceholder='you@zinkerz.com'
          passwordLabel='Password'
          passwordPlaceholder='••••••••'
          showPasswordField
          forgotText='Forgot password?'
          onForgot={() => setState(5)}
          submitLabel='Sign In'
          goSignin={() => {
            setState(2)
          }}
          goSignup={() => {
            setState(3)
          }}
        />
        <div className='help-row mt-3'>
          Need access?{' '}
          <a href='mailto:dev@zinkerz.com'>Contact your team admin</a>
        </div>
      </TabPane>
      <TabPane tabId={4}>
        <p className='form-domain'>admin.zinkerz.com</p>
        <h2 className='form-heading'>{translate('login.signup.welcome')}</h2>
        <p className='form-sub'>
          {translate('login.signup.description')}
        </p>
        <SocialSignin isEducator={isEducator === 'true'} isSignup />
        <div className='divider'>
          <span className='divider-text'>{translate('login.signup.orWithEmail')}</span>
        </div>
        <EmailSignin
          goSignin={() => setState(2)}
          goSignup={() => {
            setState(3)
          }}
        />
        <div
          className='help-row mt-3'
          onClick={() => setState(1)}
        >
          <a href='/#' onClick={(e) => e.preventDefault()}>
            &lt;&nbsp;{translate('login.signup.back')}
          </a>
        </div>
      </TabPane>
      <TabPane tabId={2}>
        <FullPassword
          isEducator={isEducator === 'true'}
          back={() => setState(1)}
          onForgot={(email) => {
            setDefaultEmail(email)
            setState(5)
          }}
        />
      </TabPane>
      <TabPane tabId={3}>
        <Signup isEducator={isEducator === 'true'} back={() => setState(1)} />
      </TabPane>
      <TabPane tabId={5}>
        <RecoveryPasswordPage
          isEducator={isEducator === 'true'}
          back={() => setState(1)}
          defaultEmail={defaultEmail}
        />
      </TabPane>
    </TabContent>
  )
}

export default Signin
